<template>
    <div class="ReportsPane">
        <div class="container-fluid container-fill">
            <div class="row">
                <div class="col-md-4">
                    <div class="paper">
                        <h4>Raiser's Edge Reports</h4>
                        <ReportDownloader report-label="I/C/S/S Meeting Report"
                                          endpoint="FundDevelopment/Reports/ICSSReport"
                                          :parameter-schema="ParamsStartEnd"
                                          report-description="Generates an organization-wide summary of RE Actions of type meeting that are of Type: Introduction, Cultivation, Solicitation, or Stewardship.  Splits TLC from Non-TLC.  Report data is synced with RE once daily, so any info added the same day as running the report will not appear until the following day." />
                        

                    </div>
                </div>
                <div class="col-md-4">
                    <div class="paper">
                        <h4></h4>
                        
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="paper">
                        <h4></h4>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import components
    import ReportDownloader from '../../Core/UI/ReportDownloader.vue';

    //import components
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faChartBar } from '@fortawesome/free-solid-svg-icons';
    library.add(faChartBar);

    export default {
        props: [],
        data: function () {
            return {
                
                ParamsStartEnd: [
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    }
                ]
            };
        },
        methods: {
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        computed: {

        },
        components: {
            ReportDownloader
        },
        mounted() {

        }
    }
</script>

<style scoped>
</style>